import { c as _c } from "react/compiler-runtime";
import type { PropsWithStyles } from '@morpho-org/ui-v6/types';
import { Skeleton } from '@morpho-org/ui-v6/server';
import { memo } from 'react';
import { useIsMobile } from '@/hooks/useBreakpoints';
export interface CuratorVaultsTableRowsSkeletonProps extends PropsWithStyles {
  rows: number;
}
const CuratorVaultsTableRowsSkeleton = t0 => {
  const $ = _c(8);
  const {
    rows,
    style
  } = t0;
  const isMobile = useIsMobile();
  let t1;
  if ($[0] !== rows) {
    t1 = Array.from({
      length: rows
    });
    $[0] = rows;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== isMobile || $[3] !== t1) {
    t2 = t1.map((_, index) => <div className="flex h-[unset] w-full" key={index}><Skeleton className="w-[100%] rounded-[20px]" style={{
        height: isMobile ? 145 : 60
      }} /></div>);
    $[2] = isMobile;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== style || $[6] !== t2) {
    t3 = <div className="max-md:gap-sm flex h-[unset] w-full flex-col gap-[10px]" style={style}>{t2}</div>;
    $[5] = style;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
};
export default memo(CuratorVaultsTableRowsSkeleton);